import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caste-verification-menu',
  templateUrl: './caste-verification-menu.component.html',
  styleUrls: ['./caste-verification-menu.component.css']
})
export class CasteVerificationMenuComponent implements OnInit {

  menuList:any;
  pageList:any;
  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Caste Verification')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/caste-verification/caste-verification-menu/caste-verification-menu.component.ts